// @flow
import menuItems from '@lumera_configs/side_menus/customer_service_menu.json';

import SideMenu from './SideMenu';

const CustomerServiceMenu = () => <SideMenu items={menuItems} />;

export default CustomerServiceMenu;
